import { atom } from 'recoil';
import { differenceInCalendarDays } from 'date-fns';

const gameNumberAtom = atom({
  key: 'gameNumber',
  default: differenceInCalendarDays(new Date(), new Date('2022-03-04')) - 1,
});

export { gameNumberAtom };
